import { Fragment } from "react";
import { Button, Table } from "react-bootstrap";
import { QueryParamUsage } from "../../../../../services/QueryParamService";
import { ownValue, QueryParamFinderState } from "./QueryParamFinderSlice";
import ParamUrlsPanel from "./ParamUrlsPanel";

export type QueryParamTableProps = {
  readonly params: readonly QueryParamUsage[];
  readonly expanded: ReadonlySet<string>;
  readonly urlState: Pick<QueryParamFinderState, "paramUrls">;
  readonly onToggle: (parameter: string) => void;
  readonly onPage: (parameter: string, offset: number) => void;
};

type RowProps = Omit<QueryParamTableProps, "params"> & { readonly param: QueryParamUsage };

const ParamRow = ({ param, expanded, urlState, onToggle, onPage }: RowProps) => {
  const name = param.paramName;
  const open = expanded.has(name);
  return (
    <Fragment>
      <tr>
        <td>{name}</td>
        <td>{param.count.toLocaleString("en-US")}</td>
        <td>{param.urlCount.toLocaleString("en-US")}</td>
        <td>
          <Button size="sm" variant="outline-primary" aria-label={`${open ? "Hide" : "View"} URLs for ${name}`} onClick={() => onToggle(name)}>
            {open ? "Hide URLs" : "View URLs"}
          </Button>
        </td>
      </tr>
      {open && (
        <tr>
          <td colSpan={4}>
            <ParamUrlsPanel view={ownValue(urlState.paramUrls, name)} onPage={(offset) => onPage(name, offset)} />
          </td>
        </tr>
      )}
    </Fragment>
  );
};

const QueryParamTable = ({ params, ...rest }: QueryParamTableProps) => (
  <Table responsive hover size="sm">
    <thead>
      <tr>
        <th>Parameter</th>
        <th>Occurrences</th>
        <th>URL Count</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      {params.map((param) => (
        <ParamRow key={param.paramName} param={param} {...rest} />
      ))}
    </tbody>
  </Table>
);

export default QueryParamTable;
